import { useStore } from '@nanostores/react';
import { useEffect } from 'react';
import { shortcutsStore } from '~/lib/stores/settings';
import type { Shortcuts } from '~/types/settings';
import type { VoidifyObject } from '~/types/typescript-helpers';
import { EventEmitter } from '~/utils/event-emitter';

type ShortcutsEvents = VoidifyObject<Shortcuts>;

export const shortcutEventEmitter = new EventEmitter<ShortcutsEvents>();

export function useShortcuts(actions: Record<keyof Shortcuts, () => void>): void {
  const shortcuts = useStore(shortcutsStore);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent): void => {
      const { key, ctrlKey, shiftKey, altKey, metaKey } = event;

      for (const name in shortcuts) {
        const shortcut = shortcuts[name as keyof Shortcuts];

        if (
          shortcut.key.toLowerCase() === key?.toLowerCase() &&
          (shortcut.ctrlOrMetaKey
            ? ctrlKey || metaKey
            : (shortcut.ctrlKey === undefined || shortcut.ctrlKey === ctrlKey) &&
              (shortcut.metaKey === undefined || shortcut.metaKey === metaKey)) &&
          (shortcut.shiftKey === undefined || shortcut.shiftKey === shiftKey) &&
          (shortcut.altKey === undefined || shortcut.altKey === altKey)
        ) {
          shortcutEventEmitter.dispatch(name as keyof Shortcuts);

          event.preventDefault();
          event.stopPropagation();

          actions[name as keyof Shortcuts]?.();

          break;
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [shortcuts]);
}
